import { Box } from '@mui/material'
import AnonymizerNav from './AnonymizerNav'
import AnonymizerRoutes from './AnonymizerRoutes'

const AnonymizerLayout = () => {
  return (
    <>
      <AnonymizerNav />
      <Box sx={{ px: 3 }}>
        <AnonymizerRoutes />
      </Box>
    </>
  )
}

export default AnonymizerLayout
